import styled from 'styled-components';
import { Select } from '@xbcb/form-item-components';

export const StyledSelect = styled(Select)`
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;
